import Seo from "@/components/Seo";
import { CONTACT } from "@/data/site";

function Legal({ title, path, children }) {
  return (
    <div className="bg-navy-900 min-h-screen">
      <Seo title={title} path={path} />
      <section className="pt-40 pb-24">
        <div className="max-w-3xl mx-auto px-6">
          <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tighter text-white leading-none">{title}</h1>
          <div className="mt-10 space-y-6 text-slate-300 leading-relaxed text-sm [&_h2]:text-white [&_h2]:font-bold [&_h2]:text-xl [&_h2]:mt-8 [&_h2]:mb-2 [&_h2]:font-heading">
            {children}
          </div>
        </div>
      </section>
    </div>
  );
}

export function Impressum() {
  return (
    <Legal title="Impressum" path="/impressum">
      <div data-testid="impressum-page">
        <h2>Angaben gemäß § 5 TMG</h2>
        <p>Xhevdet Rashica<br />VMF Versicherungsmakler Frankfurt<br />
        Versicherungsmakler · Immobilienmakler · Kredit- und Finanzierungsvermittlung<br />
        Heddernheimer Landstraße 151<br />60439 Frankfurt am Main<br />Deutschland</p>

        <h2>Kontakt</h2>
        <p>Telefon: 069 83040769<br />E-Mail: info@vm-ffm.de<br />
        Web: <a href="https://www.vm-ffm.de" className="text-gold-500 hover:underline">https://www.vm-ffm.de</a></p>

        <h2>Berufsrechtliche Angaben</h2>
        <p>Erlaubnis nach § 34d Abs. 1 GewO als Versicherungsmakler.<br />
        Vermittlerregister-Nr.: D-BT4E-ITWM0-28</p>

        <h2>Zuständige Erlaubnis- und Aufsichtsbehörde für § 34d GewO</h2>
        <p>Industrie- und Handelskammer Frankfurt am Main<br />Börsenplatz 4<br />60313 Frankfurt am Main<br />
        Telefon: +49 69 2197-0<br />
        Web: <a href="https://www.frankfurt-main.ihk.de" className="text-gold-500 hover:underline">https://www.frankfurt-main.ihk.de</a></p>

        <h2>Gemeinsame Registerstelle</h2>
        <p>Deutsche Industrie- und Handelskammer (DIHK)<br />Breite Straße 29<br />10178 Berlin<br />
        Web: <a href="https://www.vermittlerregister.info" className="text-gold-500 hover:underline">https://www.vermittlerregister.info</a></p>

        <h2>Weitere Erlaubnisse nach § 34c GewO</h2>
        <p>Erlaubnis nach § 34c Abs. 1 Nr. 1 GewO – Immobilienmakler –<br />
        Erlaubnis nach § 34c Abs. 1 Nr. 2 GewO – Darlehensvermittlung –</p>

        <h2>Zuständige Aufsichtsbehörde für § 34c GewO</h2>
        <p>Ordnungsamt der Stadt Frankfurt am Main<br />Kleyerstraße 86<br />60326 Frankfurt am Main</p>

        <h2>Berufsbezeichnung</h2>
        <p>Versicherungsmakler, Immobilienmakler und Darlehensvermittler.<br />
        Verliehen in der Bundesrepublik Deutschland.</p>

        <h2>Berufsrechtliche Regelungen</h2>
        <p>§ 34d Gewerbeordnung<br />§§ 59–68 Versicherungsvertragsgesetz<br />Versicherungsvermittlungsverordnung<br />
        § 34c Gewerbeordnung<br />Makler- und Bauträgerverordnung</p>
        <p>Die berufsrechtlichen Regelungen können über <a href="https://www.gesetze-im-internet.de" className="text-gold-500 hover:underline">https://www.gesetze-im-internet.de</a> eingesehen werden.</p>

        <h2>Außergerichtliche Streitbeilegung</h2>
        <p>Versicherungsombudsmann e. V.<br />Postfach 08 06 32<br />10006 Berlin<br />
        Web: <a href="https://www.versicherungsombudsmann.de" className="text-gold-500 hover:underline">https://www.versicherungsombudsmann.de</a></p>
        <p>Ombudsmann Private Kranken- und Pflegeversicherung<br />Postfach 06 02 22<br />10052 Berlin<br />
        Web: <a href="https://www.pkv-ombudsmann.de" className="text-gold-500 hover:underline">https://www.pkv-ombudsmann.de</a></p>
        <p>Wir sind bereit, an einem Streitbeilegungsverfahren vor den genannten Verbraucherschlichtungsstellen teilzunehmen.</p>

        <h2>Offenlegung von Beteiligungen</h2>
        <p>Xhevdet Rashica besitzt weder direkte noch indirekte Beteiligungen von mehr als 10 Prozent an den Stimmrechten oder am Kapital eines Versicherungsunternehmens oder eines Mutterunternehmens eines Versicherungsunternehmens.</p>
        <p>Ebenso besitzt kein Versicherungsunternehmen oder Mutterunternehmen eines Versicherungsunternehmens eine direkte oder indirekte Beteiligung von mehr als 10 Prozent an den Stimmrechten oder am Kapital des Vermittlers.</p>

        <h2>Verantwortlich für den Inhalt</h2>
        <p>Xhevdet Rashica, Heddernheimer Landstraße 151, 60439 Frankfurt am Main</p>

        <h2>Haftungsausschluss</h2>
        <p>Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte übernehmen wir jedoch keine Gewähr.</p>
      </div>
    </Legal>
  );
}

export function Datenschutz() {
  return (
    <Legal title="Datenschutzerklärung" path="/datenschutz">
      <div data-testid="datenschutz-page">
        <p>Der Schutz Ihrer personenbezogenen Daten ist uns wichtig. Nachfolgend informieren wir Sie gemäß Art. 13 und 14 DSGVO über die Verarbeitung personenbezogener Daten im Zusammenhang mit der Nutzung dieser Website und unserer Dienstleistungen.</p>

        <h2>1. Verantwortlicher</h2>
        <p>{CONTACT.legalName}<br />{CONTACT.street}, {CONTACT.city}<br />
        Telefon: {CONTACT.phone} · E-Mail: {CONTACT.email}</p>
        <p>Für Datenschutzanliegen erreichen Sie uns unter <a href="mailto:datenschutz@vm-ffm.de" className="text-gold-500 hover:underline">datenschutz@vm-ffm.de</a>. Verantwortliche Person: Xhevdet Rashica.</p>

        <h2>2. Erhebung und Verarbeitung personenbezogener Daten</h2>
        <p>Wir verarbeiten personenbezogene Daten, die Sie uns aktiv übermitteln – insbesondere über das Kontaktformular, die Terminbuchung, die Schadenmeldung sowie bei der Registrierung im Kundenportal. Verarbeitet werden dabei je nach Vorgang: Name, E-Mail-Adresse, Telefonnummer, gewählter Themenbereich (Versicherung, Finanzierung, Immobilien), Ihre Nachricht sowie vorgangsbezogene Angaben (z. B. Wunschtermin, Schadenart, Vertragsbezug).</p>
        <p>Rechtsgrundlagen sind Art. 6 Abs. 1 lit. b DSGVO (Anbahnung/Durchführung eines Vertrags bzw. Bearbeitung Ihrer Anfrage) sowie Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer effizienten Bearbeitung). Optionale Cookies bzw. Einwilligungen werden auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO verarbeitet.</p>

        <h2>3. Empfänger / Auftragsverarbeiter</h2>
        <p>Zur Erbringung unserer Leistungen setzen wir sorgfältig ausgewählte Dienstleister ein, mit denen – soweit erforderlich – Verträge zur Auftragsverarbeitung nach Art. 28 DSGVO bestehen:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li><strong>Resend</strong> – Versand transaktionaler E-Mails (z. B. Bestätigungen). Verarbeitet werden Empfänger-E-Mail-Adresse und Nachrichteninhalt.</li>
          <li><strong>Google</strong> – optionale Anmeldung per Google-Login sowie optionale Kalender-Synchronisation von Terminen (nur bei aktiver Nutzung).</li>
          <li><strong>Hosting-Infrastruktur</strong> – Betrieb der Anwendung und Datenspeicherung auf einer abgesicherten Cloud-Infrastruktur innerhalb der EU.</li>
        </ul>

        <h2>4. Hosting & Server-Logfiles</h2>
        <p>Beim Aufruf der Website werden automatisch technische Zugriffsdaten in Server-Logfiles verarbeitet (z. B. gekürzte/verarbeitete IP-Adresse, Datum und Uhrzeit, aufgerufene Seite, Browsertyp). Dies dient dem sicheren und stabilen Betrieb (Art. 6 Abs. 1 lit. f DSGVO). Diese Daten werden nur so lange gespeichert, wie es für diese Zwecke erforderlich ist.</p>

        <h2>5. Cookies & Einwilligung</h2>
        <p>Wir verwenden technisch notwendige Speichermechanismen (u. a. zur Anmeldung/Sitzungsverwaltung im geschützten Bereich). Optionale, nicht notwendige Cookies werden ausschließlich mit Ihrer Einwilligung über unseren Cookie-Hinweis gesetzt. Ihre Einwilligung können Sie jederzeit mit Wirkung für die Zukunft unter <a href="/cookie-einstellungen" className="text-gold-500 hover:underline">Cookie-Einstellungen</a> widerrufen.</p>

        <h2>6. Speicherdauer</h2>
        <p>Wir speichern personenbezogene Daten nur so lange, wie es für die jeweiligen Zwecke erforderlich ist oder gesetzliche Aufbewahrungspflichten (insbesondere handels- und steuerrechtliche Fristen) bestehen. Anfragedaten ohne Vertragsbezug werden nach Abschluss der Bearbeitung im Rahmen unseres automatisierten Löschkonzepts entfernt.</p>

        <h2>7. Ihre Rechte</h2>
        <p>Sie haben nach Maßgabe der gesetzlichen Voraussetzungen das Recht auf Auskunft (Art. 15), Berichtigung (Art. 16), Löschung (Art. 17), Einschränkung der Verarbeitung (Art. 18), Datenübertragbarkeit (Art. 20) sowie das Recht auf Widerspruch (Art. 21 DSGVO). Eine erteilte Einwilligung können Sie jederzeit widerrufen. Zur Ausübung genügt eine E-Mail an <a href="mailto:datenschutz@vm-ffm.de" className="text-gold-500 hover:underline">datenschutz@vm-ffm.de</a>.</p>

        <h2>8. Zuständige Aufsichtsbehörde / Beschwerderecht</h2>
        <p>Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde zu beschweren. Für uns zuständig ist:</p>
        <p>Der Hessische Beauftragte für Datenschutz und Informationsfreiheit<br />Postfach 3163<br />65021 Wiesbaden<br />
        Web: <a href="https://datenschutz.hessen.de" className="text-gold-500 hover:underline">https://datenschutz.hessen.de</a></p>

        <h2>9. Verschlüsselung (SSL/TLS)</h2>
        <p>Diese Website nutzt aus Sicherheitsgründen eine SSL-/TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie an „https://" in der Adresszeile Ihres Browsers.</p>
      </div>
    </Legal>
  );
}
